import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';

interface Props {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmColor?: 'error' | 'inherit';
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const CommunityConfirmDialog: React.FC<Props> = ({
  open,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmColor = 'inherit',
  loading,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    open={open}
    onClose={loading ? undefined : onCancel}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: { borderRadius: 3 } }}
  >
    <DialogTitle sx={{ fontWeight: 600, pb: 1 }}>{title}</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ color: '#5f6368' }}>
        {description}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
      <Button onClick={onCancel} disabled={loading} sx={{ borderRadius: 2 }}>
        {cancelLabel}
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        color={confirmColor === 'error' ? 'error' : undefined}
        disabled={loading}
        sx={
          confirmColor === 'inherit'
            ? { borderRadius: 2, bgcolor: '#606060', '&:hover': { bgcolor: '#404040' } }
            : { borderRadius: 2 }
        }
      >
        {loading ? <CircularProgress size={20} color="inherit" /> : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
